import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EmailVerifyBodyDto } from "api/Api";
import { useGetApiClient } from "api/get-api-client";

const useApiUserAuthEmailVerificationStart = () => {
  const apiClient = useGetApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: EmailVerifyBodyDto) => {
      await apiClient.user.emailVerificationStart(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["auth-new"],
      });
    },
  });
};

export default useApiUserAuthEmailVerificationStart;
